// extracted by mini-css-extract-plugin
export default {"button":"SuggestedTag_button__-H4NC"};